__webpack_require__.p = "/favoritetypes/";